import { useEffect, useState } from "react";
import { getStoredUser, hasValidSession } from "../auth/session";

interface UserData {
  user_id: string;
  user_name: string;
  user_email: string;
  profile: string; // ou { profile_name: string } se quiser usar o objeto completo
}

export function useAuth() {
  const [user_id, setUserId] = useState<number | null>(null);
  const [company_id, setCompany_id] = useState<number | null>(null);
  const [user, setUser] = useState<UserData | null>(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isManager, setIsManager] = useState(false);
  const [isOwner, setIsOwner] = useState(false);
  const [isUser, setIsUser] = useState(false);
  const [isAuthChecked, setIsAuthChecked] = useState(false);
  const [userProfile, setUserProfile] = useState<string | null>(null);

  useEffect(() => {
    // Usuário só é considerado logado com token presente e não vencido.
    const parsedUser = hasValidSession() ? getStoredUser() : null;
    if (parsedUser) {
      setUser(parsedUser as unknown as UserData);
      setIsUser(parsedUser.profile === "USER");
      setIsAdmin(parsedUser.profile === "ADMIN");
      setIsManager(parsedUser.profile === "MANAGER");
      setIsOwner(parsedUser.profile === "OWNER");
      setUserId(parsedUser.user_id);
      setCompany_id(parsedUser.company_id || null); // Define company_id se existir
      setUserProfile(parsedUser.profile);
    }
    setIsAuthChecked(true);
  }, []);

  return {
    user_id,
    user,
    isUser,
    isAdmin,
    isAuthChecked,
    userProfile,
    company_id,
    isManager,
    isOwner
  };
}
